// extracted by mini-css-extract-plugin
export default {"container":"ButtonSubmit_container__3U4z0","disable":"ButtonSubmit_disable__G3JRy","content-sent":"ButtonSubmit_content-sent__sYYy8"};